<template>
  <div class="nerv-page-shell">
    <!-- CRT power-on, once per page load. -->
    <div v-if="booting" class="crt-boot"></div>
    <div v-if="booting" class="crt-sweep"></div>

    <!-- Page-level targeting axis, over the content and under the top bar. -->
    <NervReticle />

    <NervTopBar />

    <main class="nerv-main">
      <div class="nerv-page-frame">
        <router-view :key="$route.fullPath" />
      </div>
    </main>

    <footer class="nerv-footer">
      <div class="nerv-page-frame nerv-footer-inner">
        <span class="nerv-caption">&copy; {{ year }} Dev1 Consulting, LLC</span>
        <span class="nerv-caption">Plano, Texas</span>
        <NervTicker class="footer-ticker" />
        <span class="nerv-status nerv-lcd">System nominal</span>
      </div>
    </footer>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import NervTopBar from '@/components/NervTopBar.vue';
import NervTicker from '@/components/NervTicker.vue';
import NervReticle from '@/components/NervReticle.vue';

export default defineComponent({
  name: 'App',
  components: { NervTopBar, NervTicker, NervReticle },
  data() {
    return {
      year: new Date().getFullYear(),
      booting: true,
    };
  },
  mounted() {
    // Remove the boot layers once the animation has finished so they never
    // sit in the tree intercepting anything.
    window.setTimeout(() => {
      this.booting = false;
    }, 1300);
  },
});
</script>
